import { useContext } from 'react'

import { AVCTaskContext } from 'domains/Workspaces/ContentFlows/AvcTasks/AvcTask/Task/context'

export const useSelectTaskMode = () => useContext(AVCTaskContext).taskMode
export const useSelectInitialConfigState = () => useContext(AVCTaskContext).initialConfigState
export const useSelectTaskModeSetters = () => ({ setTaskMode: useContext(AVCTaskContext).setTaskMode })
